export default __webpack_public_path__ + "static/media/pouf9.fbcfb21d.JPG";